/**
 * Quantity steppers (market tonnes, partial repair, rearm, pay extra): pure stepping and clamping on a step grid.
 */
import { EPSILON } from '../../career/ops'

/**
 * The next stepper quantity from `q` by `dir` steps of `step`, snapping to the step grid, and to `max` itself at
 * the top (so a fractional hold can be sold whole). Never below the smaller of one step and `max`, never above
 * `max`; 0 when `max` is 0.
 */
export function stepQuantity(q: number, dir: 1 | -1, step: number, max: number): number {
  if (!(max > 0)) return 0
  const min = Math.min(step, max)
  let next: number
  if (dir > 0) next = (Math.floor(q / step + EPSILON) + 1) * step
  else next = (Math.ceil(q / step - EPSILON) - 1) * step
  if (next >= max - EPSILON) return max
  return next < min ? min : next
}

/** `q` clamped into the stepper's range (the smaller of one step and `max`, up to `max`; 0 when `max` is 0). */
export function clampQuantity(q: number, step: number, max: number): number {
  if (!(max > 0)) return 0
  const min = Math.min(step, max)
  return q < min ? min : q > max ? max : q
}
